import React, { useState, useEffect } from 'react';
import { Form, Select, Spin } from 'antd';
import { CreateMT5AccountApi, GetAccountTypesApi } from '../../../api/request/client';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AccountCard from './AccountCard.jsx';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import ModalComponent from '../../../components/global/modal/ModalComponent.jsx';
import toast from 'react-hot-toast';

export default function MT5Account() {

  const params = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const accountType = searchParams.get('type');
  const [isLoading, setIsLoading] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState({});
  const [isOpenLiveForm, setIsOpenLiveForm] = useState(false);
  const [isLiveFormLoading, setIsLiveFormLoading] = useState(false);
  const [leverageOptions, setLeverageOptions] = useState([]);
  const [isOpenDemoForm, setIsOpenDemoForm] = useState(false);
  const [depositOptions, setDepositOptions] = useState([1000, 3000, 5000, 50000, 100000].map(num => ({ value: num, label: String(num) })));

  const getAcounts = async () => {
    try {
      setIsLoading(true);
      let apiParams = {
        UserId: params.id,
        AccountType: accountType === 'true' || 'demoaccount'
      }
      const { data } = await GetAccountTypesApi(new URLSearchParams(apiParams).toString());
      if (data?.success) {
        setAccountTypes(data?.data);
      }
      setIsLoading(false);
    } catch (error) { }
  }

  useEffect(() => {
    getAcounts();
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [isOpenLiveForm]);

  const createAccount = (account) => {
    const option = [1, 2, 3, 5, 10, 15, 20, 25, 33, 40, 50, 66, 75, 80, 100, 125, 150, 175, 200, 300, 400, 500, 1000, 5000];
    const availableOptions = option
      .filter(val => val <= account?.leverage)
      .map(val => ({ value: val, label: val.toString() }));
    setLeverageOptions(availableOptions);
    setSelectedAccount(account);

    if (searchParams?.get('type') == 'true') {
      setIsOpenLiveForm(true);
      return;
    }
    if (searchParams?.get('type') == 'demoaccount') {
      setIsOpenDemoForm(true);
      return;
    }
  }

  const handleDemoAccount = (values) => {
    createMT5Account(values, "demo");
  };

  const handleLiveAccount = (values) => {
    createMT5Account(values, "live");
  };


  const createMT5Account = async (values, ACtype) => {
    const isDemo = ACtype === "demo";
    try {
      setIsLiveFormLoading(true);
      let apiParams = {
        depositAmount: isDemo ? values?.depositAmount : 0,
        groupId: selectedAccount?.groupId,
        groupName: selectedAccount?.groupName,
        isDemoAccount: isDemo,
        isLiveAccount: !isDemo,
        leverage: values?.leverage,
        planId: selectedAccount?.planId,
        userId: params?.id
      }
      const { data } = await CreateMT5AccountApi(apiParams);
      if (data?.success) {
        setIsLiveFormLoading(false);
        toast?.success(data?.message);
        navigate(`/client_details/${params?.id}`);
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLiveFormLoading(false);
    }
  }

  return (
    <div>
      <div className='border rounded p-4 lg:p-6'>
        {isLoading ? (
          <div className="flex justify-center flex-col my-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <div className='flex flex-wrap justify-center items-center gap-8 mx-auto' >
            {
              accountTypes?.map((account, index) => (
                <AccountCard index={index} account={account} handleSubmit={createAccount} type={accountType === 'demoaccount' ? 'demo' : 'live'} />
              ))
            }
          </div>
        )}
      </div>

      {/* Open live account form modal */}
      <ModalComponent isOpen={isOpenLiveForm} setIsOpen={setIsOpenLiveForm} title='Open Live Account'>
        <Form className='w-full' autoComplete="off" form={form} onFinish={handleLiveAccount}>
          <div className='ant-select-selector-white'>
            <label className='text-description text-[#2F2B3DCC] font-medium'>Leverage</label>
            <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
              <Select size='large' className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase t'
              disabled={isLiveFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isLiveFormLoading}
              loadingLable='Opening Live Account...'
            />
            <button type='button' disabled={isLiveFormLoading} className='bg-red-500 text-sm text-white font-medium uppercase px-8 py-2 rounded-lg ' onClick={() => setIsOpenLiveForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>

      {/* Open demo account form modal */}
      <ModalComponent isOpen={isOpenDemoForm} setIsOpen={setIsOpenDemoForm} title='Open Demo Account'>
        <Form className='w-full' autoComplete="off" form={form} onFinish={handleDemoAccount}>
          <div className='ant-select-selector-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Deposit</label>
            <Form.Item name='depositAmount' rules={[{ required: true, message: 'Please select deposit.' }]}>
              <Select size='large' className='border-primary w-full mt-1' placeholder='Select deposit' options={depositOptions} />
            </Form.Item>
          </div>
          <div className='ant-select-selector-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Leverage</label>
            <Form.Item name='leverage' rules={[{ required: true, message: 'Please select leverage.' }]}>
              <Select size='large' className='border-primary w-full mt-1' placeholder='Select leverage' options={leverageOptions} />
            </Form.Item>
          </div>
          <div className='flex justify-center items-center gap-5 mt-10'>
            <LoadableButton
              className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
              disabled={isLiveFormLoading}
              type="Submit"
              lable='Proceed'
              isLoading={isLiveFormLoading}
              loadingLable='Opening Demo Account...'
            />
            <button type='button' disabled={isLiveFormLoading} className='bg-red-500 text-sm text-white font-medium uppercase px-8 py-2 rounded-lg hover:bg-red-600 duration-500' onClick={() => setIsOpenDemoForm(false)}>Cancel</button>
          </div>
        </Form>
      </ModalComponent>
    </div>
  )
}